module.exports = __webpack_public_path__ + "img/754000266_4.34db7b3c.jpg";